/**
 * Functions helper
 */

export class Functions {
    /**
     * @method private
     * @name getLocationOrigin
     * @description Stops event action and bubble.
     * @param e [object] "Event data"
     */
    static getLocationOrigin() {
        var a = window.location.origin;
        return window.location.origin || ( a = '//' + window.location.hostname + ( window.location.port ? ':' + window.location.port : '' ) ),
            a
    };

    static replaceStringParams( string, params ) {
        for ( var key in params ) {
            string = string.replace( new RegExp( '{' + key + '}', 'gi' ), params[ key ] );
        }
        return string;
    };

    static addUrlParams( url, params ) {
        var alreadyHasParams = url.indexOf( '?' ) !== -1;
        for ( var key in params ) {
            url += alreadyHasParams ? '&' : '?';
            alreadyHasParams = true;
            url = url + encodeURI( key ) + "=" + encodeURI( params[ key ] );
        }
        return url;
    };

    static formatNumber( number, dec_point ) {
        var parts = ( number + '' ).split( dec_point ),
            main = parts[ 0 ],
            len = main.length,
            output = '',
            i = len - 1;

        while ( i >= 0 ) {
            output = main.charAt( i ) + output;

            if ( ( len - i ) % 3 === 0 && i > 0 ) {
                output = dec_point + '' + output;
            }

            --i;
        }

        // put decimal part back
        if ( parts.length > 1 ) {
            output += dec_point + '' + parts[ 1 ];
        }

        return output;
    };

    /**
     * @method private
     * @name getCookie
     * @description ...
     * @param name [object] "Event data"
     */
    static getCookie( name ) {
        var cookie = document.cookie.match( new RegExp( '(^|;\\s*)' + name + '=([^;]*)' ) );
        return cookie && cookie[2];
    };

    /**
     * @method private
     * @name killEvent
     * @description Stops event action and bubble.
     * @param e [object] "Event data"
     */
    static killEvent( e, immediate ) {
        try {
            e.preventDefault();
            e.stopPropagation();

            if ( immediate ) {
                e.stopImmediatePropagation();
            }
        } catch( error ) {
            //
        }
    };

    /**
     * @method private
     * @name startTimer
     * @description Starts an internal timer.
     * @param timer [int] "Timer ID"
     * @param time [int] "Time until execution"
     * @param callback [function] "Function to execute"
     * @return [int] "Timer ID"
     */
    static startTimer( timer, time, callback, interval ) {
        Functions.clearTimer( timer );

        return ( interval ) ? setInterval( callback, time ) : setTimeout( callback, time );
    };

    /**
     * @method private
     * @name clearTimer
     * @description Clears an internal timer.
     * @param timer [int] "Timer ID"
     */
    static clearTimer( timer, interval ) {
        if ( timer ) {
            if ( interval ) {
                clearInterval( timer );
            }
            else {
                clearTimeout( timer );
            }

            timer = null;
        }
    };

    /**
     * @method private
     * @name sortAsc
     * @description Sorts an array (ascending).
     * @param a [mixed] "First value"
     * @param b [mixed] "Second value"
     * @return Difference between second and first values
     */
    static sortAsc( a, b ) {
        return ( parseInt( a, 10 ) - parseInt( b, 10 ) );
    };

    /**
     * @method private
     * @name sortDesc
     * @description Sorts an array (descending).
     * @param a [mixed] "First value"
     * @param b [mixed] "Second value"
     * @return Difference between second and first values
     */
    static sortDesc( a, b ) {
        return ( parseInt( b, 10 ) - parseInt( a, 10 ) );
    };

    /**
     * @method private
     * @name decodeEntities
     * @description Decodes HTML.
     * @param string [string] "String to decode"
     * @return Decoded string
     */
    static decodeEntities( string ) {
        // http://stackoverflow.com/a/1395954
        var el = Pwn_UI.document.createElement( "textarea" );
        el.innerHTML = string;

        return el.value;
    };

    /**
     * @method private
     * @name parseQueryString
     * @description Returns keyed object containing all GET query parameters
     * @param url [string] "URL to parse"
     * @return [object] "Keyed query params"
     */
    static parseQueryString( url ) {
        var params = {},
            parts = url.slice( url.indexOf( "?" ) + 1 ).split( "&" );

        for ( var i = 0; i < parts.length; i++ ) {
            var part = parts[ i ].split( "=" );
            params[ part[0] ] = part[1];
        }

        return params;
    };

    /**
     * @method private
     * @name urldecode
     * @description ...
     * @param url [string] "URL to decode"
     * @return ...
     */
    static urldecode( url ) {
        return decodeURIComponent( ( url + '' ).replace( /\+/g, '%20' ) );
    };

    /**
     * @method private
     * @name getTheTallestHeight
     * @description Return the tallest element height from a collection with the same selector
     * @param element [mixed] "Element(s) selector"
     * @return m [int] "The value of the tallest element"
     */
    static getTheTallestHeight( element ) {
        var m = 0;

        if ( ! $( element ).length ) return;

        $( element ).each( function() {
            if ( m < $( this ).outerHeight() ) {
                m = $( this ).outerHeight();
            }
        } );

        return m;
    };

    /**
     * @method private
     * @name isPrimitive
     * @description ...
     * @param ...
     * @return ...
     */
    static isPrimitive( value ) {
        return Functions.isNULL( value ) ||
            Functions.isSTRING( value ) ||
            Functions.isBOOLEAN( value ) ||
            Functions.isNUMBER( value );
    };

    /**
     * @method private
     * @name isNULL
     * @description ...
     * @param ...
     * @return ...
     */
    static isNULL( value ) {
        return value === null || value == void 0;
    };

    /**
     * @method private
     * @name isSTRING
     * @description ...
     * @param ...
     * @return ...
     */
    static isSTRING( value ) {
        return typeof value == 'string';
    };

    /**
     * @method private
     * @name isBOOLEAN
     * @description ...
     * @param ...
     * @return ...
     */
    static isBOOLEAN( value ) {
        return value === true || value === false;
    };

    /**
     * @method private
     * @name isNUMBER
     * @description ...
     * @param ...
     * @return ...
     */
    static isNUMBER( value ) {
        return ! isNaN( value ) && isFinite( value ) && ( value * 1 ) === value ? true : false;
    };

    /**
     * @method private
     * @name isComplex
     * @description ...
     * @param ...
     * @return ...
     */
    static isComplex( value ) {
        return Functions.isARRAY( value ) || Functions.isOBJECT( value );
    };

    /**
     * @method private
     * @name isARRAY
     * @description ...
     * @param ...
     * @return ...
     */
    static isARRAY( value ) {
        return Functions.isOBJECT( value ) && Functions.isNUMBER( value.length ) ? true : false;
    };

    /**
     * @method private
     * @name isOBJECT
     * @description ...
     * @param ...
     * @return ...
     */
    static isOBJECT( value ) {
        return typeof value == 'object' && value && typeof value.prototype == 'undefined' ? true : false;
    };

    /**
     * @method private
     * @name objectLength
     * @description ...
     * @param ...
     * @return ...
     */
    static objectLength( object ) {
        var length = 0, i;

        if ( ! Functions.isOBJECT( object ) ) return;

        for ( i in object ) {
            if ( object.hasOwnProperty( i ) ) {
                length++;
            }
        }

        return length ? length : false;
    };

    /**
     * @method private
     * @name getCallTime
     * @description ...
     * @param ...
     * @return ...
     */
    static getCallTime() {
        return 'called at: ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() + ':' + new Date().getMilliseconds();
    };

    /**
     * @method private
     * @name ua
     * @description A short method to get userAgent.
     * @return [string] "userAgent"
     */
    static ua() {
        return navigator.userAgent;
    };

    /**
     * @method private
     * @name is_Android
     * @description Check if Android device.
     * @return [bool] "Environment"
     */
    static is_Android() {
        return Functions.ua().match( /Android/i );
    };

    /**
     * @method private
     * @name is_BlackBerry
     * @description Check if BlackBerry device.
     * @return [bool] "Environment"
     */
    static is_BlackBerry() {
        return Functions.ua().match( /BlackBerry/i );
    };

    /**
     * @method private
     * @name is_iOS
     * @description Check if iOS device.
     * @return [bool] "Environment"
     */
    static is_iOS() {
        return Functions.ua().match( /iPhone|iPad|iPod/i );
    };

    /**
     * @method private
     * @name is_Opera
     * @description Check if Opera device.
     * @return [bool] "Environment"
     */
    static is_Opera() {
        return Functions.ua().match( /Opera Mini/i );
    };

    /**
     * @method private
     * @name is_Windows
     * @description Check if Windows device.
     * @return [bool] "Environment"
     */
    static is_Windows() {
        return Functions.ua().match( /IEMobile/i );
    };

    /**
     * @method private
     * @name is_Any
     * @description Check if any of these devices.
     * @return [bool] "Environment"
     */
    static is_Any() {
        return ( Functions.is_Android() || Functions.is_BlackBerry() || Functions.is_iOS() || Functions.is_Opera() || Functions.is_Windows() );
    };

    static hasSessionStorage() {
        try {
            return !!window.sessionStorage;
        } catch (a) {
            return !0;
        }
    };

    static hasLocalStorage() {
        try {
            return !!window.localStorage;
        } catch (a) {
            return !0;
        }
    };

    static hasIndexedDB() {
        return !!window.indexedDB;
    };

    static isIE() {
        return "Microsoft Internet Explorer" === navigator.appName || "Netscape" === navigator.appName && /Trident/.test(navigator.userAgent) ? true : false;
    };

    static inViewport(el, h) {
        var elementHeight = el.outerHeight(),
            scrolled = $(window).scrollTop(),
            viewed = scrolled + $(window).height(),
            elementTop = el.offset().top,
            elementBottom = elementTop + elementHeight,
            // if 0, the element is considered in the viewport as soon as it enters.
            // if 1, the element is considered in the viewport only when it's fully inside
            // value in percentage (1 >= h >= 0)
            h = h || 0;

        return ( elementTop + elementHeight * h ) <= viewed && ( elementBottom - elementHeight * h ) >= scrolled;
    };

    static getExecutionTime() {
        return window.performance && window.performance.timing && window.performance.now ? function() {
            return window.performance.timing.navigationStart + window.performance.now()
        }
        : function() {
            return (new Date).getTime()
        }
    }
}
